<template>
  <div>
    <div class="ppanelHeader">
      <table>
        <tr>
          <td>Buildphase</td>
          <td>
            <v-select
                id="idBuildPhase"
                :options="buildPhases"
                :value="buildPhase"
                @input="selected => setBuildPhase(selected)"
            ></v-select>
          </td>
        </tr>
        <tr>
          <td>MRDDate</td>
          <td>{{ header.MRDDate }}</td>
        </tr>
        <tr>
          <td>Receiving Location 1</td>
          <td :title="getAddressFieldBySelection(header.ReceivingLocation1)">
            <v-select
                v-if="hasMaintainerEditRight"
                id="idReceivingLocation1"
                :getOptionLabel="option => prepareReceivingLocation(option)"
                :options="addressBlocks.ReceivingLocation.addressBlock.addressFields"
                :value="header.ReceivingLocation1"
                :reduce="option =>  option.keyColumn"
                @input="selected => setSelectedHeaderField('ReceivingLocation1',selected)"
            ></v-select>
            <span v-else>
                            {{ header.ReceivingLocation1 }}
                        </span>
          </td>
        </tr>
        <tr>
          <td>Receiving Location 2</td>
          <td :title="getAddressFieldBySelection(header.ReceivingLocation2)">
            <v-select
                v-if="hasMaintainerEditRight"
                id="idReceivingLocation2"
                :getOptionLabel="option =>prepareReceivingLocation(option)"
                :options="addressBlocks.ReceivingLocation.addressBlock.addressFields"
                :value="header.ReceivingLocation2"
                :reduce="option =>  option.keyColumn"
                @input="selected => setSelectedHeaderField('ReceivingLocation2',selected)"
            ></v-select>
            <span v-else>
                            {{ header.ReceivingLocation2 }}
                        </span>
          </td>
        </tr>
        <tr>
          <td>Receiving Location 3</td>
          <td :title="getAddressFieldBySelection(header.ReceivingLocation3)">
            <v-select
                v-if="hasMaintainerEditRight"
                id="idReceivingLocation3"
                :getOptionLabel="option =>prepareReceivingLocation(option)"
                :options="addressBlocks.ReceivingLocation.addressBlock.addressFields"
                :value="header.ReceivingLocation3"
                :reduce="option =>  option.keyColumn"
                @input="selected => setSelectedHeaderField('ReceivingLocation3',selected)"
            ></v-select>
            <span v-else>
                            {{ header.ReceivingLocation3 }}
                        </span>
          </td>
        </tr>
      </table>

      <table>
        <tr>
          <td>Ford Supplier code</td>
          <td>
            <input v-if="hasMaintainerEditRight" type="text" v-model="header.FordSupplierCodeFpc">
            <span v-else>
                            {{ header.FordSupplierCodeFpc }}
                        </span>
          </td>
        </tr>
        <tr>
          <td>Customs Clearance</td>
          <td>
            <v-select
                v-if="hasMaintainerEditRight"
                id="idCustomsClearance"
                :getOptionLabel="option => prepareAddress(option)"
                :options="addressBlocks.CustomsClearance.addressBlock.addressFields"
                :value="header.CustomsClearance"
                :reduce="option => ((option.address!==undefined)?(option.address.split('\n')[0]):'')"
                @input="selected => setSelectedHeaderField('CustomsClearance',selected)"
            ></v-select>
            <span v-else>
                            {{ header.CustomsClearance }}
                        </span>
          </td>
        </tr>
        <tr>
          <td>Buyer</td>
          <td>
            <v-select
                v-if="hasMaintainerEditRight"
                id="idBuyer"
                :getOptionLabel="option => prepareAddress(option)"
                :options="addressBlocks.Buyer.addressBlock.addressFields"
                :value="header.Buyer"
                :reduce="option => ((option.address!==undefined)?(option.address.split('\n')[0]):'')"
                @input="selected => setSelectedHeaderField('Buyer',selected)"
            ></v-select>
            <span v-else>
                            {{ header.Buyer }}
                        </span>
          </td>
        </tr>
        <tr>
          <td>Disponent/ Requester</td>
          <td>
            <v-select
                v-if="hasMaintainerEditRight"
                id="idDisponentRequester"
                :getOptionLabel="option => prepareAddress(option)"
                :options="addressBlocks.DisponentRequester.addressBlock.addressFields"
                :value="header.DisponentRequester"
                :reduce="option => ((option.address!==undefined)?(option.address.split('\n')[0]):'')"
                @input="selected => setSelectedHeaderField('DisponentRequester',selected)"
            ></v-select>
            <span v-else>
                            {{ header.DisponentRequester }}
                        </span>
          </td>
        </tr>
        <tr>
          <td>Customer</td>
          <td>
            <input v-if="hasSupplierEditRight" type="text" v-model="header.Customer">
            <span v-else>
                            {{ header.Customer }}
                        </span>
          </td>
        </tr>
      </table>

      <div style="border: 2px solid #666;display: block;float: right;">
        <table>
          <tr>
            <td>Quotation No.</td>
            <td>
              <input v-if="hasSupplierEditRight" type="text" v-model="header.QuotationNo">
              <span v-else>
                              {{ header.QuotationNo }}
                          </span>
            </td>
          </tr>
          <tr>
            <td>Quotation Request Date</td>
            <td>
              <input v-if="hasSupplierEditRight" type="text" v-model="header.QuotationRequestDate">
              <span v-else>
                              {{ header.QuotationRequestDate }}
                          </span>
            </td>
          </tr>
          <tr>
            <td>Supplier Shipping Doc. No.</td>
            <td>
              <input v-if="hasSupplierEditRight" type="text" v-model="header.SupplierShippingDocNo">
              <span v-else>
                              {{ header.SupplierShippingDocNo }}
                          </span>
            </td>
          </tr>
          <tr>
            <td>Shipping Date</td>
            <td>
              <input v-if="hasSupplierEditRight" type="text" v-model="header.ShippingDate">
              <span v-else>
                              {{ header.ShippingDate }}
                          </span>
            </td>
          </tr>
          <tr>
            <td>Purchase Order No.</td>
            <td>
              <input v-if="hasSupplierEditRight" type="text" v-model="header.PurchaseOrderNo">
              <span v-else>
                              {{ header.PurchaseOrderNo }}
                          </span>
            </td>
          </tr>
        </table>

        <h3 style="clear: both;font-weight: normal;font-size: 1rem;padding: 3px;margin: 0;color: #fff;background: #666;">
          Supplier content</h3>
      </div>


    </div>

    <div style="clear: both"></div>
    <pd-button v-if="hasAdministratorRight && freeze === 'NONE'" label="+" :click="addPpanelLine"></pd-button>

    <div class="ppanelDatablock">


      <div ref="table1" class="table1 tableContainer">
        <table>
          <thead>
          <th>PART No</th>
          <th>SFX</th>
          <th>CAD Ver.</th>
          <th>Release Notice</th>
          <th>PART NAME</th>
          <th>DIESET No</th>
          <th>Die Set Ship</th>
          <th>Available at Plant</th>
          <th>Part Quantity</th>
          <th>Quality of Parts</th>
          <th>Receiving Date @ Ford</th>
          <th>Receiving Location [1] from Header Table</th>
          </thead>
          <tbody>
          <tr v-for="aLine of dataLines" v-bind:key="aLine.id">
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                class="firstColumn">
              <input v-if="hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.PARTNo">
              <span v-else>
                                {{ aLine.PARTNo }}
                            </span>

              <pd-button v-if="hasAdministratorRight" label="-" :click="()=>{removePpanelLine(aLine.id)}"
                         class="removeLineButton"></pd-button>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.SFX">
              <span v-else>
                                {{ aLine.SFX }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.CADVer">
              <span v-else>
                                {{ aLine.CADVer }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.ReleaseNotice">
              <span v-else>
                                {{ aLine.ReleaseNotice }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.PARTNAME">
              <span v-else>
                                {{ aLine.PARTNAME }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.DIESETNo">
              <span v-else>
                                {{ aLine.DIESETNo }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input type="text" @focus="setSelectedLine(aLine)" v-model="aLine.DieSetShip"></td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input type="text" @focus="setSelectedLine(aLine)" v-model="aLine.AvailableAtPlant"></td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     @blur="calculateTotals()"
                     v-model="aLine.PartQuantity">
              <span v-else>
                                {{ aLine.PartQuantity }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <v-select
                  v-if="hasSupplierEditRight"
                  id="idQualityOfPart"
                  :options="availableQualityOfParts"
                  :value="aLine.QualityOfParts"
                  @input="selected => setSelectedQualityOfPart(aLine,selected)"
              ></v-select>
              <span v-else>
                                {{ aLine.QualityOfParts }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="freeze !== 'FINISH'" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.ReceivingDateAtFord">
              <span v-else>
                                {{ aLine.ReceivingDateAtFord }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                :title="getAddressFieldBySelection(aLine.ReceivingLocationFromHeaderTable)"
            >
              <v-select
                  v-if="freeze !== 'FINISH'"
                  id="idReceivingLocationFromHeaderTable"
                  :getOptionLabel="option => prepareReceivingLocation(option)"
                  :options="addressBlocks.ReceivingLocation.addressBlock.addressFields"
                  :value="aLine.ReceivingLocationFromHeaderTable"
                  :reduce="option =>  option.keyColumn"
                  @focus="setSelectedLine(aLine)"
                  @input="selected => setSelectedRowField(aLine,'ReceivingLocationFromHeaderTable',selected)"
              ></v-select>
              <span v-else>
                                {{ aLine.ReceivingLocationFromHeaderTable }}
                            </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div ref="table2" class="table2 tableContainer">
        <table>
          <thead>
          <th>Manufacturing / pcs</th>
          <th>Labour / pcs</th>
          <th>Material / pcs</th>
          <th>Laser / pcs</th>
          <th>Total 1 / batch</th>
          <th>Laser Setup / batch</th>
          <th>Press Setup / batch</th>
          <th>CMM / batch</th>
          <th>Package / batch</th>
          <th>Total 2 / batch</th>
          <th>Transport Costs / batch</th>
          <th>Total Costs Offer / batch</th>
          <th>Remarks RFQ</th>
          </thead>

          <tbody>

          <template v-for="aLine of dataLines">
            <tr class="dataLineTop" v-bind:key="subKey('il',aLine.id)">
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
                <currencyinput
                    :editable="!freezeRFQ && hasSupplierEditRight"
                    :row="aLine"
                    field="Manufacturing"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>

              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
                <currencyinput
                    :editable="!freezeRFQ && hasSupplierEditRight"
                    :row="aLine"
                    field="Labour"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
                <currencyinput
                    :editable="!freezeRFQ && hasSupplierEditRight"
                    :row="aLine"
                    field="Material"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
                <currencyinput
                    :editable="!freezeRFQ && hasSupplierEditRight"
                    :row="aLine"
                    field="Laser"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <currencyinput
                    :editable="false"
                    :row="aLine"
                    field="Total1"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
                <currencyinput
                    :editable="!freezeRFQ && hasSupplierEditRight"
                    :row="aLine"
                    field="LaserSetup"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
                <currencyinput
                    :editable="!freezeRFQ && hasSupplierEditRight"
                    :row="aLine"
                    field="PressSetup"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
                <currencyinput
                    :editable="!freezeRFQ && hasSupplierEditRight"
                    :row="aLine"
                    field="CMM"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
                <currencyinput
                    :editable="!freezeRFQ && hasSupplierEditRight"
                    :row="aLine"
                    field="Package"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <currencyinput
                    :editable="false"
                    :row="aLine"
                    field="Total2"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
                <currencyinput
                    :editable="!freezeRFQ && hasSupplierEditRight"
                    :row="aLine"
                    field="TransportCostsPcs"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <currencyinput
                    :editable="false"
                    :row="aLine"
                    field="TotalCostsOffer"
                    :currency="rateToUse?rateToUse.sourceCurrency:null"
                    @focus="setSelectedLine(aLine)"
                    :blurFn="calculateTotals"
                ></currencyinput>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
                <input v-if="!freezeRFQ" type="text" @focus="setSelectedLine(aLine)"
                       @blur="calculateTotals()"
                       v-model="aLine.RemarksRFQ">
                <span v-else>{{ aLine.RemarksRFQ }}</span>
              </td>
            </tr>
            <tr class="dataLineBottom" v-bind:key="subKey('cl',aLine.id)">
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.Manufacturing) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.Labour) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.Material) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.Laser) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.Total1) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.LaserSetup) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.PressSetup) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.CMM) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.Package) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.Total2) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.TransportCostsPcs) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ convertCurrency(aLine.TotalCostsOffer) }}</div>
              </td>
              <td @mouseover="setHoverLine(aLine)"
                  v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }"
                  @click="setSelectedLine(aLine)">
                <div>{{ (aLine.RemarksRFQ) }}</div>
              </td>
            </tr>
          </template>

          <tr class="dataLineTop">
            <td class="invisibleField totalCostsOfferLabel" rowspan="2" colspan="9">Total Costs / Offer</td>
            <td class="summarize">
              <div>{{ summarize.Total2 }}</div>
            </td>
            <td class="summarize">
              <div>{{ summarize.TransportCostsPcs }}</div>
            </td>
            <td class="summarize">
              <div>{{ summarize.TotalCostsOffer }}</div>
            </td>
            <td class="invisibleField"></td>
          </tr>
          <tr class="dataLineBottom">
            <td class="summarize">
              <div>{{ convertCurrency(summarize.Total2) }}</div>
            </td>
            <td class="summarize">
              <div>{{ convertCurrency(summarize.TransportCostsPcs) }}</div>
            </td>
            <td class="summarize">
              <div>{{ convertCurrency(summarize.TotalCostsOffer) }}</div>
            </td>
            <td class="invisibleField"></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div ref="table3" class="table3 tableContainer">
        <table>
          <thead>
          <th>Date parts shipped from Supplier Location</th>
          <th class="">Status P/S/A</th>
          <th>Date of parts receiving at Ford Location</th>
          <th class="">Status P/S/A</th>
          <th>Part Submission Warrent No.(CMM Report No.)</th>
          <th>Date stamp incorporated in everypart?</th>
          <th>Label attached to every single part?</th>
          <th>WERS Reslease No.</th>
          <th>Stamping Plant/Production Source</th>
          <th>PR / WO number</th>
          <th>QTY Supplier</th>
          <th>Offer Sfx.</th>
          <th>Ship Sfx.</th>
          <th>QTY Shipping</th>
          <th>ICBA No.</th>
          <th>QTY Plant</th>
          <th>QTY EX75</th>
          <th>QTY Prot</th>
          <th>Receiv. Sfx.</th>
          <th>QTY Receiv.</th>
          <th>Remarks Shipping</th>
          </thead>
          <tbody>
          <tr v-for="aLine of dataLines" v-bind:key="aLine.id">

            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.DatePartsShippedFromSupplierLocation">
              <span v-else>
                                {{ aLine.DatePartsShippedFromSupplierLocation }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.StatusPSAShipped">
              <span v-else>
                                {{ aLine.StatusPSAShipped }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.DatePartsReceivingAtFordLocation">
              <span v-else>
                                {{ aLine.DatePartsReceivingAtFordLocation }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.StatusPSAReceived">
              <span v-else>
                                {{ aLine.StatusPSAReceived }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.PartSubmissionWarrentNo">
              <span v-else>
                                {{ aLine.PartSubmissionWarrentNo }}
                            </span>

            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.DateStampIncorporatedInEverypart">
              <span v-else>
                                {{ aLine.DateStampIncorporatedInEverypart }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.LabelAttachedToEverySinglePart">
              <span v-else>
                                {{ aLine.LabelAttachedToEverySinglePart }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.WERSResleaseNo">
              <span v-else>
                                {{ aLine.WERSResleaseNo }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.StampingPlantProductionSource">
              <span v-else>
                                {{ aLine.StampingPlantProductionSource }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.PNNR">
              <span v-else>
                                {{ aLine.PNNR }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.QTYSupplier">
              <span v-else>
                                {{ aLine.QTYSupplier }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.OfferSfx">
              <span v-else>
                                {{ aLine.OfferSfx }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.ShipSfx">
              <span v-else>
                                {{ aLine.ShipSfx }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasSupplierEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.QTYShipping">
              <span v-else>
                                {{ aLine.QTYShipping }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.ICBANo">
              <span v-else>
                                {{ aLine.ICBANo }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.QTYPlant">
              <span v-else>
                                {{ aLine.QTYPlant }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.QTYEX75">
              <span v-else>
                                {{ aLine.QTYEX75 }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.QTYProt">
              <span v-else>
                                {{ aLine.QTYProt }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.ReceivSfx">
              <span v-else>
                                {{ aLine.ReceivSfx }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && hasMaintainerEditRight" type="text" @focus="setSelectedLine(aLine)"
                     v-model="aLine.QTYReceiv">
              <span v-else>
                                {{ aLine.QTYReceiv }}
                            </span>
            </td>
            <td @mouseover="setHoverLine(aLine)"
                v-bind:class="{ lineHover: hoverLineId===aLine.id, lineSelected:selectedLineId===aLine.id }">
              <input v-if="!freezeShipping && (hasSupplierEditRight || hasMaintainerEditRight)" type="text"
                     @focus="setSelectedLine(aLine)"
                     v-model="aLine.RemarksShipping">
              <span v-else>
                                {{ aLine.RemarksShipping }}
                            </span>
            </td>
          </tr>

          </tbody>
        </table>
      </div>

    </div>
    <div ref="buttonbar" class="ppanelButtonBar">
      <pd-button v-if="hasSaveRight" label="Save" :click="persist"></pd-button>
      <pd-button v-if="hasFreezeRight && freeze === 'NONE'" label="Freeze RFQ" :click="doFreezeRFQ"></pd-button>
      <pd-button v-if="hasFreezeRight && freeze === 'RFQ'" label="Freeze Shipping"
                 :click="doFreezeShipping"></pd-button>
      <pd-button v-if="hasFreezeRight && freeze === 'SHIPPING'" label="Finish" :click="doFinish"></pd-button>

      <pd-button v-if="hasAdministratorRight && freeze !== 'NONE'" label="Remove Freeze"
                 :click="removeFreeze"></pd-button>

      <pd-button v-for="aExport of singleExports" v-bind:key="aExport.fileId" :datatopass="aExport.fileId"
                 :label="aExport.label" :click="doSingleExport"></pd-button>
    </div>


  </div>


</template>


<script>
import {mapGetters, mapState} from 'vuex';
import Button from "../components/button.vue";
import Currencyinput from "@/components/currencyinput";

let currentFactor = 0;
export default {

  name: 'PPanel',
  props: {
    msg: String
  },
  components: {
    Currencyinput,
    "pd-button": Button
  },
  computed: {
    ...mapState("ppanelStore", [
      "dataLines",
      "summarize",
      "buildPhase",
      "selectedLineId",
      "hoverLineId",
      "availableQualityOfParts",
      "addressBlocks",
      "rateToUse",
      "buildPhases",
      "freezeRFQ",
      "freezeShipping",
      "header"
    ]),
    ...mapGetters('ppanelStore', [
      "dataLines",
      "summarize",
      "buildPhase",
      "selectedLineId",
      "hoverLineId",
      "availableQualityOfParts",
      "addressBlocks",
      "rateToUse",
      "buildPhases",
      "freezeRFQ",
      "freezeShipping",
      "freeze",
      "hasSupplierEditRight",
      "hasMaintainerEditRight",
      "hasAdministratorRight",
      "hasSaveRight",
      "hasFreezeRight",
      "singleExports",
      "header"
    ])
  },
  methods: {
    doFreezeRFQ() {
      this.$store.commit('ppanelStore/freezeRFQ');
    },
    doFreezeShipping() {
      this.$store.commit('ppanelStore/freezeShipping');
    },
    removeFreeze() {
      this.$store.commit('ppanelStore/removeFreeze');
    },
    doFinish() {
      this.$store.commit('ppanelStore/doFinish');
    },
    doSingleExport(id) {
      this.$store.commit('ppanelStore/doSingleExport', id);
    },
    persist() {
      this.$store.commit('ppanelStore/persist', this.dataLines);
    },
    prepareReceivingLocation(option) {
      let res = ("[" + option.keyColumn + '] - ' + ((option.address !== undefined) ? option.address.substr(0, 10).trim() + '...' : ''));
      res = res.trim();
      return res;
    },
    prepareAddress(option) {
      if (option.address !== undefined) {
        const strings = option.address.split("\n");
        return strings[0] + " - " + ((strings[1]) ? strings[1].substr(0, 10).trim() : '');
      }
      return "";
    },
    addPpanelLine() {
      this.$store.commit('ppanelStore/addPpanelLine');
    },
    removePpanelLine(alineId) {
      this.$store.commit('ppanelStore/removePpanelLine', alineId);
    },
    setSelectedLine(aline) {
      this.$store.commit('ppanelStore/setSelectedLine', aline);
    },
    setSelectedHeaderField(fieldName, selected) {
      this.header[fieldName] = selected;
    },
    setBuildPhase(selected) {
      this.$store.commit('ppanelStore/setBuildPhase', selected);
    },
    setSelectedRowField(row, fieldName, selected) {
      row[fieldName] = selected;
    },
    setSelectedQualityOfPart(aLine, selected) {
      aLine.QualityOfParts = selected;
    },
    setHoverLine(aline) {
      this.$store.commit('ppanelStore/setHoverLine', aline);
    },
    subKey(sub, key) {
      return sub + "-" + key;
    },
    calculateTotals() {
      this.$store.commit('ppanelStore/calculateTotals');
    },
    appendUserCurrency(event) {
      const inField = event.target;
      const currentValue = inField.value;
      const currency = this.rateToUse

      if (!currentValue.endsWith(" " + currency)) {
        inField.value = currentValue + " " + currency;
      }
      console.log(this.rateToUse);
    },
    convertCurrency(value) {
      if (value !== "" && this.rateToUse) {
        return (parseFloat(value) * parseFloat(this.rateToUse.exchangeRate)).toFixed(2) + "€"
      }
      return "";
    },
    getAddressFieldBySelection(selection) {
      if (this.addressBlocks.ReceivingLocation.addressBlock.addressFields) {
        const fields = this.addressBlocks.ReceivingLocation.addressBlock.addressFields;
        for (let field of fields) {
          if (field.keyColumn == selection) {
            return field.keyColumn + "\n------\n" + field.address;
          }
        }
      }
      return "-";
    },
    syncScroll(elements) {
      for (let elem of elements) {
        elem.addEventListener('scroll', function (e) {
          const currentTarget = e.currentTarget;
          const currentTable = currentTarget;// currentTarget.getElementsByTagName("table")[0].getElementsByTagName("th")[0];
          const offsetH = currentTable.offsetHeight;
          const scrollTop = currentTarget.scrollTop;
          const scrollFactor = scrollTop / offsetH;

          if (currentFactor != scrollFactor) {
            currentFactor = scrollFactor;

            requestAnimationFrame(() => {

              for (let toTrigger of elements) {
                if (toTrigger !== currentTarget) {
                  toTrigger.scrollTop = Math.round(currentFactor * currentTable.offsetHeight);
                }
              }
            });

          }
        });
      }
    }
  },
  async created() {
    await this.$store.commit('ppanelStore/loadFromDb');
  },
  mounted() {
    let t1 = this.$refs["table1"];
    let t2 = this.$refs["table2"];
    let t3 = this.$refs["table3"];

    this.syncScroll([t1, t2, t3]);

  }
}
</script>